var showAxisLabels = false;
var format = {
  year: '%Y',
  month: '%b %Y'
};
export var chartOptions = function chartOptions(theme, period) {
  return {
    credits: {
      enabled: false
    },
    accessibility: {
      enabled: false
    },
    chart: {
      type: 'column',
      backgroundColor: theme.chartsBackgroundColor
    },
    legend: {
      enabled: false
    },
    title: {
      text: null
    },
    subtitle: {
      text: null
    },
    xAxis: {
      lineColor: theme.chartsAxisColor,
      title: {
        enabled: showAxisLabels,
        text: 'Mes'
      },
      type: 'datetime'
    },
    yAxis: {
      endOnTick: false,
      showLastLabel: false,
      showFirstLabel: false,
      title: {
        enabled: showAxisLabels,
        text: 'Rentabilidad'
      }
    },
    tooltip: {
      xDateFormat: '%Y-%m-%d',
      headerFormat: '',
      pointFormat: "{point.x:".concat(format[period] || format.month, "}<br>{point.y:.2f}%")
    },
    plotOptions: {
      column: {
        pointPadding: 0,
        borderWidth: 1,
        borderRadius: theme.chartsBarBorderRadius,
        zones: [{
          value: 0,
          color: theme.chartsBarDownColor,
          borderColor: theme.chartsBarDownBorderColor
        }, {
          color: theme.chartsBarUpColor,
          borderColor: theme.chartsBarUpBorderColor
        }]
      }
    },
    series: []
  };
};